export default "__VITE_ASSET__2a9abec1__"